import { render } from "./Committee.vue?vue&type=template&id=7ac462ff&scoped=true&ts=true"
import script from "./Committee.ts?vue&type=script&lang=ts"
export * from "./Committee.ts?vue&type=script&lang=ts"

import "./Committee.scss?vue&type=style&index=0&id=7ac462ff&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac462ff"]])

export default __exports__